<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>
           
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="fingerprint"
                                name="identifier"
                                v-model="form.identifier"
                                :label="$t('kinva.kinvaDoc.labels.identifier')"
                                :placeholder="$t('kinva.kinvaDoc.labels.identifier')"
                                :error="hasInputErrors('identifier')"
                                :error-messages="getInputErrors('identifier')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>
    
 
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="title"
                                name="title"
                                v-model="form.title"
                                :label="$t('kinva.kinvaDoc.labels.title')"
                                :placeholder="$t('kinva.kinvaDoc.labels.title')"
                                :error="hasInputErrors('title')"
                                :error-messages="getInputErrors('title')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>
    
 
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="document_scanner"
                                name="size"
                                v-model="form.size"
                                :label="$t('kinva.kinvaDoc.labels.size')"
                                :placeholder="$t('kinva.kinvaDoc.labels.size')"
                                :error="hasInputErrors('size')"
                                :error-messages="getInputErrors('size')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>
    
        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    
    
    
    

    

    export default {
        name: "KinvaDocForm",
        mixins: [InputErrorsByProps, RequiredRule    ],
        
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        },
        data(){
            return {
                
            }
        }
    }
</script>

<style scoped>

</style>

